<lib-question-display [question]="_question.value" />
<ion-grid>
  <ion-col size="12">
    <ion-row>
      <ion-col class="bullets" size="1">
        @for (control of answers.controls; track control; let index = $index) {
          <ion-row>
            @if (_question.listType === ListType.NUMBERS) {
              <span> {{ index + 1 }}. </span>
            }
            @if (_question.listType === ListType.LETTERS) {
              <span> {{ Alfabet[index] }}. </span>
            }
            @if (_question.listType === ListType.BULLETS) {
              <span> * </span>
            }
          </ion-row>
        }
      </ion-col>
      <ion-col size="11">
        <ion-reorder-group
          (ionItemReorder)="reorderItems($event)"
          [disabled]="_question.listType === 'BULLETS'"
        >
          @for (
            control of answers.controls;
            track control;
            let index = $index
          ) {
            <div class="answer-div">
              <ion-input
                class="answer-text"
                [formControl]="control"
                placeholder="Vul hier je antwoord in."
                maxlength="255"
              />
              <ion-reorder slot="end" />
            </div>
          }
        </ion-reorder-group>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-grid>
